import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { CommonHttpService } from '../services/http.service';
import { Subject } from 'rxjs/Subject';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CartRowsUpdaterService } from '../../cart/services/cart-rows-updater.service';

@Injectable()
export class CartRestorerResolver implements Resolve<any> {
    private restoredSource: Subject<any> = new Subject();
    public restored$ = this.restoredSource.asObservable();

    constructor(
        protected toastr: ToastrService,
        protected translate: TranslateService,
        protected http: CommonHttpService,
        protected cartRowsService: CartRowsUpdaterService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        if (route.queryParams.hasOwnProperty('code')) {
            this.cartRowsService.indexed$.subscribe(items => {
                this.resolveRestored(items);
            });
            this.restore(route.queryParams['code']);
        } else {
            this.indexCartRowsAndDefineCartCode();
        }

        return this.restored$;
    }

    /**
     * Call to index cart rows and then define cart code query string parameter.
     **/
    private indexCartRowsAndDefineCartCode() {
        this.cartRowsService.indexed$.subscribe(items => {
            this.resolveRestored(items);
        });
        this.cartRowsService.refresh().subscribe();
    }

    /** Call API to restore cart from code */
    private restore(code: string) {
        this.http.post(
            `checkout/cart/${code}/restore`
        ).subscribe(() => {
            this.cartRowsService.refresh().subscribe();
        }, () => {
            this.translate
                .get(['CART_RESTORER.ERROR.TITLE', 'CART_RESTORER.ERROR.MESSAGE'])
                .subscribe(error => {
                    this.toastr.error(
                        error['CART_RESTORER.ERROR.MESSAGE'],
                        error['CART_RESTORER.ERROR.TITLE'],
                        {}
                    );
                });

            this.cartRowsService.refresh().subscribe();
        });
    }
    /** Emit restored events */
    private resolveRestored(items) {
        this.restoredSource.next(items);
        this.restoredSource.complete();

        // Reset observable
        this.restoredSource = new Subject();
        this.restored$ = this.restoredSource.asObservable();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/shared/resolvers/cart-restorer.resolver.ts